import { UI } from '../nextpage';

export class Tables {
    constructor(private NP: UI) {
        // Table Components
        this.NP.registerEvent("tableNavigationClick", (e: Event) => {
            const clicked = e.target as HTMLElement;
            let relatedTable = clicked.parentElement.nextElementSibling; // this is getting the as-of element for metrics
            if (relatedTable.classList.contains("as-of")) {
                relatedTable = relatedTable.nextElementSibling;
            }
            const isMetrics = relatedTable.classList.contains("metrics");
            const navListItems = clicked.parentElement.querySelectorAll("li");
            let targetHeading;
            let navIndex = -1;
            navListItems.forEach((li, i) => {
                if (li.classList.contains("selected")) {
                    navIndex = i;
                    return;
                }
            });
        
            // Define the target heading to show based on whether the previous/next button was clicked.
            if (clicked.classList.contains("previous")) {
                if (navIndex === -1 || navIndex === 0) {
                    targetHeading = navListItems.length - 1;
                } else {
                    targetHeading = navIndex - 1;
                }
            } else {
                if (navIndex === -1) {
                    targetHeading = 1;
                } else if (navIndex === navListItems.length - 1) {
                    targetHeading = 0;
                } else {
                    targetHeading = navIndex + 1;
                }
            }
        
            // Set the selected heading and corresponding column.
            // If this is a metrics table the first column is always visible and is skipped for this selection.
            const tdTarget = (targetHeading);
            const metricsTarget = (targetHeading + (isMetrics ? 1 : 0));
        
            navListItems.forEach((nav, i) => {
                nav.classList.toggle("selected", (i === tdTarget));
            });
        
            relatedTable.querySelectorAll("tr").forEach((row) => {
                row.querySelectorAll("th").forEach((th, i) => {
                    th.classList.toggle("selected", (i === metricsTarget));
                });
                row.querySelectorAll("td").forEach((td, i) => {
                    td.classList.toggle("selected", (i === metricsTarget));
                });
            });
        });
        
        NP.components.table = (selector: string | Element | NodeListOf<Element> | Array<Element>): void => {
            this.NP.getComponentSelector(selector).forEach((table: HTMLTableElement) => {
                const tblHeadings = table.querySelectorAll("tr > th");
                const tblNav = document.createElement("ul");
                tblNav.classList.add("nav-list");
                const tblMetrics = table.classList.contains("metrics");
                const tblClass = table.getAttribute("class");
                const tblClasses = (tblClass === undefined || tblClass === null || tblClass === "") ? "" : " " + tblClass;
                    
                let selectedNth = -1;
                const asof = document.createElement("div");
                asof.classList.add("as-of");
            
                tblHeadings.forEach((heading: HTMLElement, i: number) => {
                    // If this is the first heading in a metrics table it should be the "As of Date" heading.
                    if (i === 0 && tblMetrics) {
                        asof.innerHTML = heading.innerHTML;
                        return;
                    }
                    const newLi = document.createElement("li");
                    newLi.innerHTML = heading.innerHTML;
                    // Add a list element to the table navigation list and if selected add the selected class.
                    if (heading.classList.contains("selected")) {
                        selectedNth = i + 1;
                        newLi.classList.add("selected");
                    }
                    tblNav.appendChild(newLi);
                });
            
                // If no pre-selected heading was found make the first heading selected (or second in a metrics table)
                if (selectedNth === -1) {
                    selectedNth = tblMetrics ? 1 : 0;
                    tblNav.children[0].classList.toggle("selected", true);
                }
                table.querySelectorAll("tr").forEach((row: HTMLElement) => {
                    row.children[selectedNth].classList.toggle("selected", true);
                });
            
                // Create a wrapper for the navigation then add the next/previous controls and the navigation list.
                const prevButton = document.createElement("div");
                prevButton.classList.add("nav-control", "previous");
                prevButton.addEventListener("click", (e: Event) => this.NP.events.tableNavigationClick(e));
        
                const nextButton = document.createElement("div");
                nextButton.classList.add("nav-control", "next");
                nextButton.addEventListener("click", (e: Event) => this.NP.events.tableNavigationClick(e));
        
                const navWrapper = document.createElement("div");
                navWrapper.classList.add("mobile-nav");
                navWrapper.appendChild(prevButton);
                navWrapper.appendChild(nextButton);
                navWrapper.appendChild(tblNav);
            
                // Wrap the table and prepend the navigation wrapper and metrics-related "as of date" element.
                let tblWrapper = document.createElement("div");
                tblWrapper.className = "table-wrapper" + tblClasses;
                tblWrapper.appendChild(navWrapper);
                if (tblMetrics) {
                    tblWrapper.appendChild(asof);
                }
                tblWrapper = table.parentElement.insertBefore(tblWrapper, table);
                tblWrapper.appendChild(table);
            });
        };

    };
}